import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  mt4: {
    marginTop: theme.spacing(4)
  },
  mt1: {
    marginTop: theme.spacing(1)
  }
}));
